<span [innerHtml]="text | snMarked | snLinkify | snSanitizeHtml"></span>
<span class="edited text-message__edited" *ngIf="isEdited">({{ 'common.edited' | t }})</span>
